import { useEffect } from 'react';
import { hideBoot } from './utils/boot';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { PageTransition } from './utils/motion';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { HeaderProvider } from './components/layout/HeaderContext';
import ScrollToTop from './components/ScrollToTop';
import { scrollTopNow } from './utils/scroll';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Portfolio from './pages/Portfolio';
import WorkDetail from './pages/WorkDetail';
import ServiceDetail from './pages/ServiceDetail.tsx';
import BlogDetail from './pages/BlogDetail';
import SectorDetail from './pages/SectorDetail';
import Gallery from './pages/Gallery';
import UiKit from './pages/UiKit';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" onExitComplete={scrollTopNow}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/about" element={<PageTransition><About /></PageTransition>} />
        <Route path="/services" element={<PageTransition><Services /></PageTransition>} />
        <Route path="/services/:id" element={<PageTransition><ServiceDetail /></PageTransition>} />
        <Route path="/secteurs/:id" element={<PageTransition><SectorDetail /></PageTransition>} />
        <Route path="/portfolio" element={<PageTransition><Portfolio /></PageTransition>} />
        <Route path="/works/:id" element={<PageTransition><WorkDetail /></PageTransition>} />
        <Route path="/blog" element={<PageTransition><Blog /></PageTransition>} />
        <Route path="/blog/:id" element={<PageTransition><BlogDetail /></PageTransition>} />
        <Route path="/galerie" element={<PageTransition><Gallery /></PageTransition>} />
        {import.meta.env.DEV && <Route path="/ui-kit" element={<UiKit />} />}
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  // Filet de sécurité: l'écran de démarrage disparaît même si la page d'accueil n'affiche pas de hero.
  useEffect(() => hideBoot(6000), []);
  return (
      <HeaderProvider>
    <Router>
        <ScrollToTop />
        <div className="App min-h-screen bg-white">
          <div className="relative w-full overflow-x-clip">
            <Header />
            <main>
              <AnimatedRoutes />
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </HeaderProvider>
  );
}

export default App;